export default "__VITE_ASSET__5ae980a1__"